import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import { recomputeSimulationsForModification } from '../actionCreators';
import { useDispatch } from 'react-redux';
import { showLoading } from 'actions/actionCreators/httpActions';

const OfferReinitializationComponent = ({
  t,
  offerHeader,
  history,
  documentId,
  siteId,
  openReinitializationForm,
  onChangeOpenReinitializationConfirmBool,
  setReinitializationProcessing
}) => {
  const dispatch = useDispatch();
  const handleRecomputeSimulations = () => {
    dispatch(showLoading(true));
    setReinitializationProcessing(true);
    dispatch(recomputeSimulationsForModification({ documentId, siteId })).then(data => {
      setReinitializationProcessing(false);
      dispatch(showLoading(false));
      const { documentId, siteId } = data.eventBody;
      history.push(`/offers/${documentId}/${siteId}`);
    });
    onChangeOpenReinitializationConfirmBool(false);
  };

  const handleClose = () => {
    onChangeOpenReinitializationConfirmBool(false);
  };

  return (
    <Dialog
      open={openReinitializationForm}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>{t('OfferEdit.Dialog.ConfirmReinitializationTitle')}</DialogTitle>
      <DialogContent>{t('OfferEdit.Dialog.ConfirmReinitializationDescription', { data: offerHeader })}</DialogContent>
      <DialogActions>
        <Button id={'offerReinit_dialog_acceptBtn'} color='primary' autoFocus onClick={handleRecomputeSimulations}>
          {t('OfferEdit.Client.Dialog.AcceptButton')}
        </Button>
        <Button id={'offerReinit_dialog_rejectBtn'} color='primary' onClick={handleClose}>
          {t('OfferEdit.Client.Dialog.RejectButton')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

OfferReinitializationComponent.propTypes = {
  t: PropTypes.func.isRequired,
  offerHeader: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  openReinitializationForm: PropTypes.bool.isRequired,
  onChangeOpenReinitializationConfirmBool: PropTypes.func.isRequired,
  setReinitializationProcessing: PropTypes.func.isRequired
};

export default compose(withTranslation())(OfferReinitializationComponent);
